import { actions as labelActions } from 'actions/labels';
import { actions as settingsActions } from 'actions/settings';

const settings = (state = {}, action) => {
  const { type, payload } = action;

  switch (type) {
    case labelActions.initLabels:
      return payload.settings;
    case settingsActions.resetValue: {
      const startScreen = state[payload.screen].screens[0];
      const screens = [
        {
          ...startScreen,
          data: startScreen.data.map((item) => {
            const newItem = payload.item;

            if (item.label === newItem.label) {
              return newItem;
            }

            return item;
          })
        },
        ...state[payload.screen].screens.slice(1)
      ];

      return {
        ...state,
        [payload.screen]: {
          ...state[payload.screen],
          screens
        }
      };
    }
    case settingsActions.updateItem:
      return {
        ...state,
        [payload.screen]: {
          ...state[payload.screen],
          list: state[payload.screen].list.map((item) => {
            const newItem = payload.item;

            if (item.name === newItem.name) {
              return newItem;
            }

            return item;
          })
        }
      };
    default:
      return state;
  }
};

export default settings;



// WEBPACK FOOTER //
// ./src/reducers/settings.js